import { useCallback } from "react"
import { useDispatch } from "react-redux"
import { logOutAction } from "../../../../../mp-core/redux/modules/users"
import { User } from "../../../../../mp-database/types/User"
import { trackEvent } from "../../../../../mp-utils/generic-utils/Events/eventService"
import {
  EventAction,
  EventCategory,
  EventLabel
} from "../../../../../mp-utils/generic-utils/Events/types"
import { eventChain } from "../../../../../mp-utils/generic-utils/Events/EventChainProvider"
import { generateEventMetadata, faLogEvent } from "../../../../../mp-utils/generic-utils/Events/helpers"

export const useLogoutAction = (user: User) => {
  const dispatch = useDispatch() as any

  const handleLogout = useCallback(async () => {
    faLogEvent(
      EventCategory.AUTH,
      EventAction.LOGOUT,
      EventLabel.REPORTING,
      generateEventMetadata({
        userId: user.id,
        userRole: user.role,
        eventAction: EventAction.LOGOUT,
        districtId: user.schoolDistrict,
        schoolId: user.school
      })
    )

    trackEvent({
      type: EventAction.LOGOUT,
      category: EventCategory.AUTH,
      label: EventLabel.REPORTING,
    }, "fa", generateEventMetadata({
      userId: user.id,
      userRole: user.role,
      eventAction: EventAction.LOGOUT,
      districtId: user.schoolDistrict,
      schoolId: user.school,
    }))

    eventChain.resetChain()
    dispatch(await logOutAction())
  }, [user])

  return { handleLogout }
}
